import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

type ConfigurationCriteriaProductsRecapHeaderProps = {
  totalSkus: number;
  validSkus: number;
  invalidSkus: number;
};

export function ConfigurationCriteriaProductsRecapHeader({
  totalSkus,
  validSkus,
  invalidSkus,
}: ConfigurationCriteriaProductsRecapHeaderProps): ReactElement {
  const { t } = useTranslation('configuration');

  return (
    <div className='grid grid-cols-3 gap-4 rounded-lg bg-secondary-default p-4 dark:bg-layout'>
      <div className='text-center'>
        <div className='text-2xl font-bold text-secondary-foreground'>
          {totalSkus}
        </div>
        <div className='text-sm text-layout-foreground-secondary'>
          {t('Total')}
        </div>
      </div>
      <div className='text-center'>
        <div className='text-2xl font-bold text-success-default'>
          {validSkus}
        </div>
        <div className='text-sm text-layout-foreground-secondary'>
          {t('Valid')}
        </div>
      </div>
      <div className='text-center'>
        <div className='text-2xl font-bold text-error-default'>
          {invalidSkus}
        </div>
        <div className='text-sm text-layout-foreground-secondary'>
          {t('Invalid')}
        </div>
      </div>
    </div>
  );
}
